import { render, staticRenderFns } from "./DbBottomSheet.vue?vue&type=template&id=faf39ebc&scoped=true&"
import script from "./DbBottomSheet.vue?vue&type=script&lang=ts&"
export * from "./DbBottomSheet.vue?vue&type=script&lang=ts&"
import style0 from "./DbBottomSheet.vue?vue&type=style&index=0&id=faf39ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf39ebc",
  null
  
)

export default component.exports